import React, { createContext, useCallback, useContext, useRef, useState } from "react";
import styles from "./ConfirmProvider.module.css";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [request, setRequest] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((options) => {
    const config = typeof options === "string" ? { message: options } : options;
    return new Promise((resolve) => {
      resolver.current = resolve;
      setRequest({
        title: config.title || "Are you sure?",
        message: config.message,
        confirmLabel: config.confirmLabel || "Confirm",
        cancelLabel: config.cancelLabel || "Cancel",
        danger: config.danger || false,
      });
    });
  }, []);

  const close = useCallback((result) => {
    setRequest(null);
    if (resolver.current) {
      resolver.current(result);
      resolver.current = null;
    }
  }, []);

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {request && (
        <div className={styles.overlay} onClick={() => close(false)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()} role="alertdialog" aria-modal="true">
            <h3 className={styles.title}>{request.title}</h3>
            <p className={styles.message}>{request.message}</p>
            <div className={styles.actions}>
              <button type="button" className={styles.cancelBtn} onClick={() => close(false)}>
                {request.cancelLabel}
              </button>
              <button
                type="button"
                className={request.danger ? styles.dangerBtn : styles.confirmBtn}
                onClick={() => close(true)}
              >
                {request.confirmLabel}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error("useConfirm must be used within a ConfirmProvider");
  }
  return ctx;
}
